import { Box, Breadcrumbs, CircularProgress, Container, Link, Typography } from '@material-ui/core';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { CouponPackMasterForm } from './Form';
import { MenuHeaderTemplate } from '../../../components/templates/MenuHeaderTemplate';
import { PathParams } from '../../../App';
import {
  CouponPackMasterFormInput,
  CouponPackMasterFormProps,
  CouponPackMasterImageBodyProps,
} from '../../../types/couponPackMaster';
import { OrganizationContext } from '../../../components/contexts/organization';
import { useUpdateCouponPackMaster } from './hooks/update-coupon-pack';

export type UpdateCouponPackMasterPageProps = {
  organization?: OrganizationContext;
  initialLoading: boolean;
  previousValues?: CouponPackMasterFormInput;
  submitStepMessage?: string;
  onSubmit: (input: CouponPackMasterFormInput) => void;
  logoImageProps: CouponPackMasterImageBodyProps;
  couponImageProps: CouponPackMasterImageBodyProps;
  loading: boolean;
};

export const UpdateCouponPackMaster: React.FC<UpdateCouponPackMasterPageProps> = (props) => {
  if (!props.previousValues) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  const formProps: CouponPackMasterFormProps = {
    loading: props.loading,
    onSubmit: props.onSubmit,
    previousValues: {
      ...props.previousValues,
      products: props.previousValues.products.map((it) => ({
        ...it,
        value: it.id,
        label: it.couponMasterCode,
      })),
    },
    submitStepMessage: props.submitStepMessage,
    logoImageProps: props.logoImageProps,
    couponImageProps: props.couponImageProps,
    submitLabel: '作成する',
    isUpdate: true,
  };

  return <CouponPackMasterForm {...formProps} />;
};

export const UpdateCouponPackMasterPage: React.FC = () => {
  const history = useHistory();
  const { couponPackMasterId } = useParams<PathParams>();
  const useCaseUpdate = useUpdateCouponPackMaster(couponPackMasterId);

  return (
    <MenuHeaderTemplate header={{ title: '回数券マスタの更新' }}>
      <Container maxWidth="xl">
        <Breadcrumbs>
          <Link
            href="#"
            onClick={() =>
              history.push({
                pathname: '/coupon-pack-masters',
                search: history.location.search,
              })
            }
          >
            回数券マスタ一覧
          </Link>
          <Link
            href="#"
            onClick={() =>
              history.push({
                pathname: `/coupon-pack-masters/${couponPackMasterId}`,
                search: history.location.search,
              })
            }
          >
            回数券マスタ詳細
          </Link>
          <Typography>回数券マスタの更新</Typography>
        </Breadcrumbs>
        <Box>
          <UpdateCouponPackMaster {...useCaseUpdate} />
        </Box>
      </Container>
    </MenuHeaderTemplate>
  );
};
